export default {
  title: {
    companyListTitle: 'Company List',
    companyDetailTitle: 'Company Detail',
    editCompanyTitle: 'Edit Company',
    premiumManagementTitle: 'Premium Setup'
  },
  menu: {
    companyListMenu: 'Company List',
    companyDetailMenu: 'Company Detail',
    editCompanyMenu: 'Edit Company',
    premiumManagementMenu: 'Premium Setup'
  },
  label: {
    all: 'All',
    pending: 'Pending',
    new: 'New',
    rejected: 'Rejected',
    approved: 'Approved',
    closed: 'Closed',
    reject: 'Reject',
    approve: 'Approve',
    close: 'Close',
    withinOneMonth: 'Within 1 month',
    withinTwoMonth: 'Within 2 month',
    companyName: 'Company Name',
    registeredDate: 'Registered Date',
    status: 'Status',
    expirationDate: 'Expiration Date',
    functions: 'Functions',
    companyStatusTip: 'Confirm you want to change company status to "{status}"?',
    purgeDataTip: 'Confirm you want to clear all candidate data?',
    view: 'View',
    onWeb: 'On Website',
    onApp: 'On APP',
    basicInfo: 'Basic Info',
    companyDescription: 'Company Profile',
    contactInformation: 'Contact Information',
    contactPerson: 'Contact Person:',
    contactPhone: 'Phone:',
    companyWebsite: 'Company Website',
    companyCreator: 'Company Creator',
    companyCreatorEmail: 'Company Creator Email',
    businessLicense: 'Business License',
    businessLicenseNumber: 'Business License Number',
    businessLicenseWithColon: 'Business License',
    companyChineseDisplayName: 'Company Chinese Display Name',
    companyEnglishDisplayName: 'Company English Display Name',
    companyChineseRegisteredName: 'Company Chinese Registered Name',
    companyEnglishRegisteredName: 'Company English Registered Name',
    contactPersonName: 'Contact Person Name',
    contactPersonMobileNumber: 'Contact Person Mobile Number',
    companyType: 'Company Type',
    industry: 'Industry',
    yearFoundedInGreaterChina: 'Years Founded in Greater China',
    employeesInGreaterChina: 'Employees in Greater China',
    location: 'Location',
    countryOrRegion: 'Country / Region',
    numberOfLocationsOrBranchesInChina: 'Number of Locations / Branches in China',
    provinceOrState: 'Province / State',
    cityOrTown: 'City / Town',
    logo: 'Company Logo',
    logoTip: '(Upload company logo with {width}X{height} px, jpg or png)',
    licenseNumber: 'Business License Number',
    licenseTip: '(If your business license has not yet been approved, please provide a scanned copy of the legal representative’s ID card. We will then follow-up with you on the business license.)',
    address: 'Registered Address',
    website: 'Company Website',
    attractiveWords: 'Attractive Words',
    companyChineseDescription: 'Company Description (Chinese)',
    companyEnglishDescription: 'Company Description (English)',
    public: 'Public',
    yes: 'Yes',
    no: 'No',
    emailSuffix: 'Company Email Domain',
    emailSuffixExample: '(Input company email domain, E.g. If your company email is abc@def.com, the company email domain is def.com)',
    privacy: 'New Applicant Privacy Setting',
    privacySettingOpenTitle: 'Open - Select this if you are interested in finding a job quickly',
    privacySettingOpenContent: 'Enables any AJINGA member employer to view your full information including your profile and assessment results. Typically fresh graduates will set their profile to “Open”.',
    privacySettingSemiOpenTitle: 'Semi Open - Select this if you are looking for new opportunities',
    privacySettingSemiOpenContent: 'Enables any AJINGA member employer to view your partial, non personally identifiable information. Typically candidates who are already working but would like to confidentially explore other employment opportunities,' +
      'will set their profile to “Semi-Open”. This information does NOT include your identity (name) or contact information. It DOES include information about you such as title, years of experience etc. which is required to understand if there a potential match between you and ' +
      'an employment opportunity. NOTE - in this mode, when you apply to an open position or follow a company, you grant access to (only) that AJINGA member employer to view your full information.',
    privacySettingPrivateTitle: 'Private - Select this if you not looking for new opportunities',
    privacySettingPrivateContent: 'In private mode, no AJINGA member employer will be able to see any part of your information (unless you have previously applied to a job there or are following that company). Typically candidates who are no longer actively looking for work will set their profile to ' +
      'PRIVATE. NOTE - when an AJINGA member employer updates their system to indicate you are now employed by that organization, your account will automatically be set to “Private”. You may manually adjust this status at any time.',
    candidateStatus: 'Candidate Status Management',
    candidateStatusCnName: 'Candidate status CN name',
    candidateStatusEnName: 'Candidate status EN name',
    validOrganization: 'Please note your company account will not be approved without a valid organization number, business certificate and registered address.',
    companyListAdsFirstLevel: 'First Stage',
    companyListAdsSecondLevel: 'Second Stage',
    companyListAdsThirdLevel: 'Third Stage',
    hmReviewingSystem: 'Hiring Manager Reviewing System',
    interviewSchedulingSystem: 'Interview Scheduling System',
    quicklyCreateTeamsMeeting: 'Quickly Create Teams Meeting',
    viewHmAvailability: 'View Hiring Manager Availability',
    referralTypeRegular: 'Regular',
    referralTypeLite: 'Lite',
    employeeIndependency: 'Employee Independency',
    employeeSharing: 'Employee Sharing',
    allowEmployeeApplyJob: 'Allow Employee Applications',
    pointsRewords: 'Points Rewards',
    primaryAdsImage: 'COMPANY IMAGE',
    subAdsImage: 'COMPANY SUB IMAGE',
    adsImageTip: '(Upload company logo with 980X300 px, jpg or png)',
    adsLink: 'COMPANY TARGET LINK',
    adsLinkExample: '(For Example: https://www.ajinga.com/)',
    settingEmail: 'Email Setting',
    settingChannel: 'Select Channel',
    companyLevel: 'Company Level',
    jobLevel: 'Job Level',
    settingColor: 'Color Setting',
    hiddenWebPageBottomStatement: "Hide 'Powered by ajinga.com'",
    agencyJustShow: 'Directly show candidate contact info once uploaded',
    periodicity: 'After',
    day: 'Day(s)',
    jobPosterImage: 'Image Poster',
    jobPosterVideo: 'Video Poster',
    ambassadorPoster: 'Enable Ambassador Function',
    satisfactionSurveyCandidate: 'Candidate',
    satisfactionSurveyHm: 'Hiring Manager',
    candidateConfirmToDelete: 'Candidate must click to DELETE',
    candidateConfirmToDeleteTip: 'If take NO action to STAY in talent pool',
    candidateConfirmToStay: 'Candidate must click to STAY',
    candidateConfirmToStayTip: 'If take NO action will auto-DELETE from in talent pool',
    deleteDirectly: 'Delete directly',
    resetAllExpireDate: 'Setting the time with one click',
    viewCompanyUserList: 'VIEW USERS ACCOUNT',
    premiumSettingTip: 'Premium setup',
    sendInterviewSMS: 'Interview SMS',
    automatedScheduler: 'Automated Scheduler',
    parseResumeTag: 'Candidate portrait',
    autoPostJob: 'Auto Post Job',
    manualPostJob: 'Manual Post Job',
    smsSend: 'SMS Service'
  },
  premiumType: {
    hierarchy: 'Hierarchical Display',
    vendor_management: 'Agency Management',
    candidate_upload: 'ADD CANDIDATE',
    status_cause_management: 'Candidate Status Management',
    birthday_notice: 'Birthday Notice',
    'rate-management': 'Interview Management',
    receive_resume_email: 'EMAIL TO RECEIVE RESUME',
    duplicate_candidate: 'Duplicate Check',
    satisfaction_survey: 'Satisfaction Survey',
    video_navigation: 'Video Library',
    submit_resume: 'REFERRER SUBMIT CANDIDATE',
    rpa_job_posting: 'Automated Job Posting',
    assessments: 'ASSESSMENTS',
    open_api_management: 'OpenAPI Management',
    copy_candidate: 'Copy Candidate(s)',
    data_purge: 'Candidate Data Purge',
    export_data: 'Export Data',
    post_applicant: 'Experience Portal(s)',
    application_form: 'Application Form',
    resume_match: 'Resume Fit',
    custom_mobile_landing_page: 'Landing Page',
    alumni_management: 'Alumni Management',
    referral: 'REFERRAL',
    post_job: 'POST JOB',
    auto_post_job: 'Auto Post Job',
    manual_post_job: 'Manual Post Job',
    custom_email: 'Customize Message Template',
    sms_send: 'SMS Service',
    consent_sms_send: 'Consent SMS',
    other_sms_send: 'Other SMS (Interview, AI Interview, 3rd party assessment, Birthday notice)',
    applicant_lock: 'Candidate Lock/Status Logic',
    user_num: 'USER NUMBER',
    upload_video: 'VIDEO APPLICATION',
    job_poster: 'Job Poster',
    job_num: 'JOB NUMBER',
    onboarding: 'Onboarding',
    job_board_point_dashboard: 'Job Board Point Management',
    re_apply: 'Re-Apply',
    job_custom_field: 'Job Custom Field',
    company_expire: 'COMPANY ACCOUNT',
    candidate_relationship_management: 'Candidate Relationship Management',
    soft_user: 'Leads',
    color_customization: 'Style Customization',
    hr_dashboard: 'HR Dashboard',
    wechat_template_message: 'WeChat Message Template',
    company_list_level: 'COMPANY LEVEL IN JOB LIST',
    custom_job_detail: 'Customize Job Detail Page',
    upload_portfolio: 'Attachment Survey',
    rpa_management: 'RPA Management',
    chatbot_prescreen_survey_management: 'Applicant Prescreen Section Questionnaire',
    candidate_search: 'CANDIDATE SEARCH',
    ai_summary: 'AI Resume Summary',
    non_consent_candidate_change_status_logic: 'Non-Consented candidate status logic',
    ai_resume_match: 'AI Fit Score',
    boss_application_forwarding: 'BOSS APPLICATION FORWARDING',
    microsite_campaign_management: 'Microsite And Campaign Management',
    tag_management: 'Tag Management',
    preference_survey_management: 'Preference Survey Management',
    crm_parse_resume_sdk_tag: 'Candidate Portrait',
    ai_comparison: 'AI Comparison',
    ai_talent_recommended: 'AI Talent Pool Recommender',
    offer_management: 'Offer Management',
    hr_report: 'BI Report',
    ai_interview: 'AI Interview',
    candidate_status_update_notification_internal: 'Candidate Status Update Notification (Internal)',
    similar_candidate: 'AI Talent Twins',
    ai_chat_search: 'AJINGA Intelligence Search',
    ai_resume_parse: 'AI Resume Parse',
    ai_candidate_search_filter: 'AI Candidate Filter',
    ai_chatbot: 'AI Chatbot'
  },
  premiumCategories: {
    basic_config: 'Basic Configuration',
    recruiting_config: 'Recruiting Configuration',
    career_brand_config: 'Career/Brand Configuration',
    referral_config: 'Referral Configuration',
    interview_config: 'Interview Configuration',
    crm_config: 'CRM Configuration',
    onboarding_config: 'Onboarding Configuration',
    data_config: 'Data Configuration',
    ai_config: 'AI Configuration'
  },
  btn: {
    upload: 'Upload',
    premiumSetup: 'Premium Setup',
    pending: 'Pending',
    new: 'New',
    rejected: 'Reject',
    approved: 'Approve',
    closed: 'Close',
    assign: 'Assign',
    continue: 'Continue',
    register: 'Register'
  },
  placeholder: {
    inputCompanyName: 'Search for a company by title',
    emailSuffixPlaceholder: 'e.g. def.com',
    keywords: 'Keywords search',
    selectDate: 'Please select a date'
  },
  message: {
    expireDateError: 'The expiration date of the premium: {name} cannot be null.',
    wrongNumberFormat: 'The premium: {name} is not in the correct format.',
    wrongPhotoFileType: 'Please upload {imageType} type image',
    resetExpireDateSuccess: 'Set successful!',
    emailSuffixError: 'Invalid character, only can input letter, number, and "-"'
  }
}
